import React from 'react'

import { useAmplitudeContext } from '~/components/providers/AmplitudeEventProvider'
import { graphql } from '~/gql'
import { type LogEventInput } from '~/gql/graphql'
import { useCommonQueryCurrentBrandAccount } from '~/hooks/useCommonQuery'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation UseLogEvent_LogEvent($event: LogEventInput!) {
    logEvent(event: $event) {
      ok
    }
  }
`)

type LogEventOption = Omit<LogEventInput, 'brandAccountId' | 'eventName'> & {
  withAnalysisName?: boolean
  withSuffix?: boolean
}

export const useLogEvent = () => {
  const graphQLRequest = useGraphQLRequest()

  const currentBrandAccount = useCommonQueryCurrentBrandAccount()
  const brandAccountId = currentBrandAccount?.id
  const context = useAmplitudeContext()

  return React.useCallback(
    (
      eventName: LogEventInput['eventName'],
      {
        deviceId,
        eventProperties,
        withAnalysisName = false,
        withSuffix = false,
      }: LogEventOption = {},
    ) => {
      const eventNameWithContext = `${eventName}${
        withSuffix && context?.eventNameSuffix
          ? `${context.eventNameSuffix}`
          : ''
      }${
        withAnalysisName && context?.analysisName
          ? ` ${context.analysisName}`
          : ''
      }`

      if (process.env.NODE_ENV !== 'production') {
        console.log(eventNameWithContext, {
          brandAccountId,
          deviceId,
          eventProperties,
        })

        return
      }

      graphQLRequest({
        document,
        variables: {
          event: {
            eventName: eventNameWithContext,
            brandAccountId,
            deviceId,
            eventProperties,
          },
        },
      })
    },
    [
      brandAccountId,
      context?.analysisName,
      context?.eventNameSuffix,
      graphQLRequest,
    ],
  )
}
